import React, { useState, useMemo } from "react";
import { useDateFilteredLeads } from "@/hooks/useDateFilteredData";
import { useUsers } from "@/hooks";
import { getCumulativeStatuses } from "@/constants/globalConstants";
import { useCustomerFilters as useLeadFilters } from "@/pages/contacts/hooks/useCustomerFilters";
import { InlineLoader as Loader, Tabs, HeroBanner } from "@/components/ui";
import ExpenseApprovalTab from "../components/expense_approval_tab";
import OrderApprovalTab from "../components/order_approval_tab";
import EstimationApprovalTab from "../components/estimation_approval_tab";
import ApprovalsStatsCards from "../components/approvals_stats_cards";
import { ReceiptIndianRupee, Package, IndianRupee } from "lucide-react";

export default function ApprovalsScreen() {
  const [activeTab, setActiveTab] = useState("materials");

  const {
    debouncedSearch,
    filters,
    page,
    sortBy
  } = useLeadFilters();

  const queryParams = useMemo(() => ({
    search: debouncedSearch,
    page,
    limit: 100, // Fetch up to 100 pending approvals for now
    status: getCumulativeStatuses('customer_acceptance'),
    sort: sortBy
  }), [debouncedSearch, page, sortBy]);

  // Force the filter status to 'customer_acceptance' so it only fetches those leads
  const { data: leadsData, isLoading: leadsLoading, refetch } = useDateFilteredLeads(queryParams, { ...filters, status: 'customer_acceptance' });
  const { teamMembers } = useUsers({ limit: 1000, includeOwner: true });

  const rawLeads = Array.isArray(leadsData) ? leadsData : (leadsData?.leads || leadsData?.projects || []);
  const leads = rawLeads.map(l => ({ ...l, isLocked: false }));

  const tabs = [
    // { id: "quotation", label: "Initial Quotation Approval", icon: ClipboardCheck },
    { id: "expenses", label: "Expense Approval", icon: IndianRupee },
    { id: "materials", label: "Order Approval", icon: Package },
    { id: "budget", label: "Discount Approval", icon: IndianRupee },
    // { id: "additional", label: "Stage Revert", icon: FileQuestion },
    // { id: "appliances", label: "Ordering Approvals", icon: CheckSquare },
    // { id: "sales", label: "Sale Approvals", icon: CheckSquare }
  ];

  return (
    <div className="flex flex-col gap-6 w-full max-w-full pb-2 overflow-x-hidden">
      <HeroBanner
        title="Approvals Management"
        subtitle="Space Designs Approvals Management"
      />

      <ApprovalsStatsCards />

      <div className="flex flex-col gap-2">
        <div className="">
          <Tabs
            tabs={tabs}
            activeTab={activeTab}
            onChange={setActiveTab}
            variant="sub"
          />
        </div>

        <div className="flex flex-col">

          {activeTab === "expenses" && <ExpenseApprovalTab />}
          {activeTab === "materials" && <OrderApprovalTab />}
          {activeTab === "budget" && <EstimationApprovalTab />}
        </div>
      </div>

    </div>
  );
}